import React from 'react'

const PencilIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 12 12' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M0 12V9.16667L8.8 0.383333C8.93333 0.261111 9.08056 0.166667 9.24167 0.1C9.40278 0.0333333 9.57222 0 9.75 0C9.92778 0 10.1 0.0333333 10.2667 0.1C10.4333 0.166667 10.5778 0.266667 10.7 0.4L11.6167 1.33333C11.75 1.45556 11.8472 1.6 11.9083 1.76667C11.9694 1.93333 12 2.1 12 2.26667C12 2.44444 11.9694 2.61389 11.9083 2.775C11.8472 2.93611 11.75 3.08333 11.6167 3.21667L2.83333 12H0ZM9.73333 3.2L10.6667 2.26667L9.73333 1.33333L8.8 2.26667L9.73333 3.2Z'
      fill='currentcolor'
    />
  </svg>
)

export default PencilIcon
